module.exports = __webpack_public_path__ + "static/media/1080x1080_post_L7_happy.da9cffd2.jpg";